/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OffersSummaryInfo
 */
export interface OffersSummaryInfo {
    /**
     * 
     * @type {string}
     * @memberof OffersSummaryInfo
     */
    head: string;
    /**
     * 
     * @type {number}
     * @memberof OffersSummaryInfo
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof OffersSummaryInfo
     */
    approved: number;
}

/**
 * Check if a given object implements the OffersSummaryInfo interface.
 */
export function instanceOfOffersSummaryInfo(value: object): value is OffersSummaryInfo {
    if (!('head' in value) || value['head'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('approved' in value) || value['approved'] === undefined) return false;
    return true;
}

export function OffersSummaryInfoFromJSON(json: any): OffersSummaryInfo {
    return OffersSummaryInfoFromJSONTyped(json, false);
}

export function OffersSummaryInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OffersSummaryInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'head': json['head'],
        'total': json['total'],
        'approved': json['approved'],
    };
}

export function OffersSummaryInfoToJSON(json: any): OffersSummaryInfo {
    return OffersSummaryInfoToJSONTyped(json, false);
}

export function OffersSummaryInfoToJSONTyped(value?: OffersSummaryInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'head': value['head'],
        'total': value['total'],
        'approved': value['approved'],
    };
}

